<template>
    <div>
        <table>
            <tr>
                <td>フリンジ品番を選ぶ</td>
                <td>
                    <b-form-select v-model="fringe_selected"
                                   :options="$store.state.xlsx_select_data.select_data[$store.state.xlsx_data.style_data[$store.state.step2_data.style_selected1_id].group1][$store.state.step2_data.style_selected1_name]['フリンジ品番を選ぶ'].option"></b-form-select>

                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "multicover",
        created : function(){
            if(this.fringe_selected === ''){
                this.fringe_selected = this.$store.state.xlsx_select_data.select_data[this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1][this.$store.state.step2_data.style_selected1_name]['フリンジ品番を選ぶ'].option[0].value
            }
        },
        watch: {
            style_selected1_name:function(value){
                if(this.fringe_selected === ''){
                    this.fringe_selected = this.$store.state.xlsx_select_data.select_data[this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1][this.$store.state.step2_data.style_selected1_name]['フリンジ品番を選ぶ'].option[0].value
                }
            }
        },
        computed: {
            fringe_selected: {
                get: function () {
                    return this.$store.state.step3_data.fringe
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'fringe', value:value})
                }
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
        },
    }
</script>

<style scoped>

</style>